import useOrganisationId from "../../organisations/hooks/useOrganisationId";
import { useHasAccessFunctions } from "../../../hooks/useHasAccess";
import useLang from "../../../hooks/useLang";

const useReportsPage = () => {
  const lang = useLang();
  const organisationId = useOrganisationId();
  const { hasAccessToLink } = useHasAccessFunctions();

  const page = {
    hasAccess: hasAccessToLink(`/${organisationId}/reports`),
    header: {
      title: lang("reports.title"),
      /*
      buttons: [
        {
          caption: "Formuoti nauja",
          to: `/${organisationId}/reports/new`,
        },
      ],
      */
    },
  };

  return page;
};

export default useReportsPage;
